import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/layout/Layout';
import Login from './pages/Login';
import ProtectedRoute, { GuestOnlyRoute } from './components/auth/ProtectedRoute';
import { useAuth } from './context/AuthContext';

// Lazy-loaded pages
const Dashboard = React.lazy(() => import('./pages/Dashboard'));
const Beacons = React.lazy(() => import('./pages/Beacons'));
const BeaconEditar = React.lazy(() => import('./pages/BeaconEditar'));
const RedesWifi = React.lazy(() => import('./pages/RedesWifi'));
const Trenes = React.lazy(() => import('./pages/Trenes'));
const TrenEditar = React.lazy(() => import('./pages/TrenEditar'));
const Posiciones = React.lazy(() => import('./pages/Posiciones'));
const Interior = React.lazy(() => import('./pages/Interior'));
const HistoricoPosiciones = React.lazy(() => import('./pages/HistoricoPosiciones'));
const Alerts = React.lazy(() => import('./pages/Alerts'));
const Agentes = React.lazy(() => import('./pages/Agentes'));
const AgenteEditar = React.lazy(() => import('./pages/AgenteEditar'));
const Configuracion = React.lazy(() => import('./pages/Configuracion'));
const Sessions = React.lazy(() => import('./pages/Sessions'));
const Dispositivos = React.lazy(() => import('./pages/Dispositivos'));
const DispositivoDetalle = React.lazy(() => import('./pages/DispositivoDetalle'));
const Plantas = React.lazy(() => import('./pages/Plantas'));
const PlantaDetalle = React.lazy(() => import('./pages/PlantaDetalle'));
const Estaciones = React.lazy(() => import('./pages/Estaciones'));

function SuspenseWrapper({ children }: { children: React.ReactNode }) {
    return (
        <React.Suspense fallback={<div className="p-8 text-muted-foreground">Cargando...</div>}>
            {children}
        </React.Suspense>
    );
}

function CatchAll() {
    const { isAuthenticated } = useAuth();
    return <Navigate to={isAuthenticated ? '/dashboard' : '/login'} replace />;
}

export function AppRouter() {
    return (
        <Routes>
            <Route path="/login" element={<GuestOnlyRoute><Login /></GuestOnlyRoute>} />
            <Route
                element={
                    <ProtectedRoute>
                        <Layout />
                    </ProtectedRoute>
                }
            >
                <Route path="/dashboard" element={<SuspenseWrapper><Dashboard /></SuspenseWrapper>} />
                <Route path="/posiciones" element={<SuspenseWrapper><Posiciones /></SuspenseWrapper>} />
                <Route path="/interior" element={<SuspenseWrapper><Interior /></SuspenseWrapper>} />
                <Route path="/historico" element={<SuspenseWrapper><HistoricoPosiciones /></SuspenseWrapper>} />
                <Route path="/plantas" element={<SuspenseWrapper><Plantas /></SuspenseWrapper>} />
                <Route path="/plantas/:id" element={<SuspenseWrapper><PlantaDetalle /></SuspenseWrapper>} />
                <Route path="/beacons" element={<SuspenseWrapper><Beacons /></SuspenseWrapper>} />
                <Route path="/beacons/nuevo" element={<SuspenseWrapper><BeaconEditar /></SuspenseWrapper>} />
                <Route path="/beacons/:id/editar" element={<SuspenseWrapper><BeaconEditar /></SuspenseWrapper>} />
                <Route path="/estaciones" element={<SuspenseWrapper><Estaciones /></SuspenseWrapper>} />
                <Route path="/redes-wifi" element={<SuspenseWrapper><RedesWifi /></SuspenseWrapper>} />
                <Route path="/trenes" element={<SuspenseWrapper><Trenes /></SuspenseWrapper>} />
                <Route path="/trenes/nuevo" element={<SuspenseWrapper><TrenEditar /></SuspenseWrapper>} />
                <Route path="/trenes/:id/editar" element={<SuspenseWrapper><TrenEditar /></SuspenseWrapper>} />
                <Route path="/alertas" element={<SuspenseWrapper><Alerts /></SuspenseWrapper>} />
                <Route path="/agentes" element={<SuspenseWrapper><Agentes /></SuspenseWrapper>} />
                <Route path="/agentes/nuevo" element={<SuspenseWrapper><AgenteEditar /></SuspenseWrapper>} />
                <Route path="/agentes/:id/editar" element={<SuspenseWrapper><AgenteEditar /></SuspenseWrapper>} />
                <Route path="/dispositivos" element={<SuspenseWrapper><Dispositivos /></SuspenseWrapper>} />
                <Route path="/dispositivos/:id" element={<SuspenseWrapper><DispositivoDetalle /></SuspenseWrapper>} />
                <Route path="/configuracion" element={<SuspenseWrapper><Configuracion /></SuspenseWrapper>} />
                <Route path="/sesiones" element={<SuspenseWrapper><Sessions /></SuspenseWrapper>} />
            </Route>
            <Route path="*" element={<CatchAll />} />
        </Routes>
    );
}
